import { useQuery } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";
import type { ListParams } from "../components";

export type AuditEntry = { id: string; category: string; action: string; summary: string; actor_email: string; actor_name: string; on_behalf_of: string; target_type: string; target_id: string; target_label: string; changes: Record<string, unknown>; ip_address: string | null; user_agent: string; request_id: string; created_at: string };

export function useAuditLog(params: ListParams) {
  return useQuery({
    queryKey: ["audit-log", params],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/audit/log/", { params: { query: params as never } });
      if (error) throw new Error(errorMessage(error));
      return data as unknown as { count: number; results: AuditEntry[] };
    },
  });
}
